module.exports = __webpack_public_path__ + "img/couples-069.c58b3ff3.jpg";